// Mock data for JMJC Contracting

export const COMPANY = {
  name: "JMJC Contracting",
  shortName: "JMJC",
  tagline: "Residential Remodeling, Built to Last.",
  description:
    "Family-run craftsmen specializing in tile, flooring, drywall, and full kitchen & bathroom transformations. Quality workmanship, honest pricing, and finished on time.",
  phone: "+1 (904) 420-0832",
  email: "hello@jmjccontracting.com",
  address: "211 East 43rd Street, Suite 6th Floor, PMB 70611, New York, NY 10017",
  hours: "Mon – Sat · 7:00 AM – 6:00 PM",
  founded: 2025,
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Gallery", path: "/gallery" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export const STATS = [
  { value: "2025", label: "Established" },
  { value: "100%", label: "Licensed & insured" },
  { value: "Free", label: "In-home estimates" },
  { value: "NJ · NY", label: "Tri-State service" },
];

export const SERVICES = [
  {
    slug: "kitchen-remodeling",
    title: "Kitchen Remodeling",
    short: "Custom kitchens designed for the way you actually cook.",
    description:
      "From layout reconfigurations and custom cabinetry to quartz countertops and tile backsplashes — we deliver kitchens that age beautifully.",
    image:
      "https://images.unsplash.com/photo-1638886043487-72d203fa66b6?q=85&w=1600&auto=format&fit=crop",
    bullets: [
      "Custom cabinetry & islands",
      "Quartz, granite & butcher block tops",
      "Tile backsplashes & flooring",
      "Lighting & electrical updates",
    ],
  },
  {
    slug: "bathroom-remodeling",
    title: "Bathroom Remodeling",
    short: "Spa-grade bathrooms with hidden craftsmanship.",
    description:
      "Walk-in showers, custom tilework, vanity installs, and full waterproofing done right the first time. We handle plumbing, tile, and finish carpentry under one roof.",
    image: "/projects/img3534.jpg",
    bullets: [
      "Walk-in & curbless showers",
      "Schluter & Kerdi waterproofing",
      "Vanity & fixture installation",
      "Heated floors & lighting",
    ],
  },
  {
    slug: "tiling",
    title: "Tiling",
    short: "Precision tile installation, every line dialed in.",
    description:
      "Floor tile, wall tile, mosaics, large format and natural stone. Proper substrate prep, level setting, and crisp grout lines — the details that separate a 5-year job from a 30-year one.",
    image: "/projects/img3535.jpg",
    bullets: [
      "Large format & natural stone",
      "Mosaic & decorative patterns",
      "Heated floor systems",
      "Substrate & subfloor prep",
    ],
  },
  {
    slug: "flooring",
    title: "Flooring",
    short: "Hardwood, LVP, and tile — installed level and built to last.",
    description:
      "Engineered hardwood, solid plank, luxury vinyl, and porcelain tile. We level, underlay, and fasten properly so floors stay flat, quiet, and tight for decades.",
    image:
      "https://images.unsplash.com/photo-1770838773417-08b18661c62f?q=85&w=1600&auto=format&fit=crop",
    bullets: [
      "Engineered & solid hardwood",
      "Luxury vinyl plank (LVP)",
      "Porcelain & ceramic tile",
      "Subfloor leveling & moisture barriers",
    ],
  },
  {
    slug: "drywall",
    title: "Drywall & Finishing",
    short: "Smooth walls, level-5 finishes, zero call-backs.",
    description:
      "Hanging, taping, mud, and finish work — including Level 4 and Level 5 finishes. Patches, ceiling repair, texture matching, and full new-build drywall.",
    image:
      "https://images.unsplash.com/photo-1581094271901-8022df4466f9?q=85&w=1600&auto=format&fit=crop",
    bullets: [
      "Level 4 & Level 5 finishes",
      "Patch & texture matching",
      "Ceiling & water damage repair",
      "Soundproofing assemblies",
    ],
  },
  {
    slug: "general-remodeling",
    title: "General Remodeling",
    short: "Full-room transformations from demo to final coat.",
    description:
      "Basement build-outs, additions, full home refreshes. One crew, one project manager, and one schedule — we run the whole job so you don’t have to chase trades.",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?q=85&w=1600&auto=format&fit=crop",
    bullets: [
      "Basement finishing",
      "Whole-home refreshes",
      "Demo, framing & finish carpentry",
      "Project management end-to-end",
    ],
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Walkthrough",
    body: "We visit your home, listen to what you want, measure carefully, and talk through what’s realistic for your space and budget.",
  },
  {
    n: "02",
    title: "Estimate & Plan",
    body: "You get a clear, line-itemed quote. No vague allowances or surprise change orders mid-project.",
  },
  {
    n: "03",
    title: "Build",
    body: "One dedicated crew, daily clean-up, and a project manager who actually returns texts. We respect that this is your home.",
  },
  {
    n: "04",
    title: "Final Walk",
    body: "We don’t leave until you’ve walked every inch and signed off. Two-year workmanship warranty included.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Marcus & Linda P.",
    location: "Park Slope, Brooklyn",
    project: "Full Kitchen Remodel",
    quote:
      "JMJC turned our 1980s kitchen into the heart of our home. They showed up when they said, cleaned every day, and the tilework is borderline obsessive. Worth every dollar.",
  },
  {
    name: "Renee K.",
    location: "Upper East Side, Manhattan",
    project: "Master Bathroom",
    quote:
      "I’d been burned by two contractors before finding JMJC. They re-tiled my shower properly with real waterproofing. A year later — zero issues. These guys actually care.",
  },
  {
    name: "David O.",
    location: "Astoria, Queens",
    project: "LVP Flooring · Whole Home",
    quote:
      "1,800 sq ft of luxury vinyl in four days, perfectly level. They moved my furniture, did the prep, and left it cleaner than they found it. Already booked them for the basement.",
  },
  {
    name: "The Chen Family",
    location: "Williamsburg, Brooklyn",
    project: "Drywall + Basement Finish",
    quote:
      "Walls so smooth you can see them under raking light. Ceilings, transitions, paint-ready. Top tier craftsmanship and genuinely good people to have in your house.",
  },
];

export const GALLERY = [
  {
    id: "jmjc-1",
    title: "Subway Tile Bath — In Progress",
    category: "Tiling",
    location: "Recent JMJC project",
    // Real JMJC job: mid-installation shot of subway tile with gray mosaic accent band
    before: "/projects/img3214.jpg",
    after: "/projects/img3535.jpg",
  },
  {
    id: "jmjc-2",
    title: "Custom Soap Niche Tilework",
    category: "Bathroom",
    location: "Recent JMJC project",
    // Real JMJC job: subway tile with built-in soap-dish niche and gray marble mosaic band
    before: "/projects/img3215.jpg",
    after: "/projects/img3534.jpg",
  },
  {
    id: "jmjc-3",
    title: "Vintage Bathtub Surround",
    category: "Bathroom",
    location: "Recent JMJC project",
    // Real JMJC job: existing subway + marble mosaic tile bath, before full refresh
    before: "/projects/img3536.jpg",
    after: "/projects/img3535.jpg",
  },
  {
    id: "g4",
    title: "Wide Plank Hardwood",
    category: "Flooring",
    location: "Hoboken, NJ",
    before:
      "https://images.unsplash.com/photo-1503602642458-232111445657?q=85&w=1400&auto=format&fit=crop",
    after:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=85&w=1400&auto=format&fit=crop",
  },
  {
    id: "g5",
    title: "Open Concept Living",
    category: "General",
    location: "Bay Ridge, Brooklyn",
    before:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?q=85&w=1400&auto=format&fit=crop",
    after:
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=85&w=1400&auto=format&fit=crop",
  },
  {
    id: "g6",
    title: "Smooth Wall Refinish",
    category: "Drywall",
    location: "Forest Hills, Queens",
    before:
      "https://images.unsplash.com/photo-1581094271901-8022df4466f9?q=85&w=1400&auto=format&fit=crop",
    after:
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=85&w=1400&auto=format&fit=crop",
  },
  {
    id: "g7",
    title: "Quartz Island Kitchen",
    category: "Kitchen",
    location: "Riverdale, The Bronx",
    before:
      "https://images.unsplash.com/photo-1556909114-44e3e9399a2f?q=85&w=1400&auto=format&fit=crop",
    after:
      "https://images.unsplash.com/photo-1556909190-eccf4a8bf97a?q=85&w=1400&auto=format&fit=crop",
  },
];

export const GALLERY_CATEGORIES = [
  "All",
  "Kitchen",
  "Bathroom",
  "Tiling",
  "Flooring",
  "Drywall",
  "General",
];

export const VALUES = [
  {
    title: "Show up.",
    body: "When we say 7:30, we mean 7:30. Predictable schedules, daily updates, and a real human you can call.",
  },
  {
    title: "Build it right.",
    body: "Proper substrates. Real waterproofing. Square, plumb, level. The boring stuff is what makes work last.",
  },
  {
    title: "Finish clean.",
    body: "We protect floors, vacuum daily, and walk every inch with you before invoicing the final dollar.",
  },
];

export const SERVICE_AREAS = [
  "Manhattan",
  "Brooklyn",
  "Queens",
  "The Bronx",
  "Staten Island",
  "Jersey City",
  "Hoboken",
  "Newark",
  "Union City",
  "Bayonne",
  "Fort Lee",
  "Weehawken",
  "Elizabeth",
  "North Bergen",
];
